// extracted by mini-css-extract-plugin
export default {"pdf":"pdf__pdf-eqppa"};